import { Component } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-invalid-otp',
  standalone: true,
  imports: [HeaderComponent, RouterModule],
  templateUrl: './invalid-otp.component.html',
  styleUrl: './invalid-otp.component.scss'
})
export class InvalidOtpComponent {

}
